import {
  CLEAR_TUTOR_DATA,
  FETCH_TUTOR_SENT,
  FETCH_TUTOR_SUCCEEDED,
  FETCH_TUTOR_FAILED,
} from '../../actions/tutor';

const initialState = {
  status: null,
  loading: false,
  id: null,
  permalink: null,
  tutor: null,
  onlineStatus: false,
};

export default function tutorDataReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case CLEAR_TUTOR_DATA:
      return initialState;
    case FETCH_TUTOR_SUCCEEDED:
      return {
        ...state,
        loading: false,
        id: payload.user.id,
        permalink: payload.user.permalink_url,
        tutor: payload.user,
        onlineStatus:
          typeof payload.online_status.online !== 'undefined'
            ? payload.online_status.online
            : false,
      };
    case FETCH_TUTOR_FAILED:
      const { message } = payload;
      let status;
      switch (message) {
        case 'Inactive Tutor':
          status = 'inactive';
          break;
        default:
          status = 'access_restricted';
          break;
      }
      return {
        ...state,
        status,
        loading: false,
      };
    case FETCH_TUTOR_SENT:
      return {
        ...state,
        status: null,
        loading: true,
      };
    default:
      return state;
  }
}
